import { useState } from 'react';

import { wait } from '@braskai/ui-kit';

import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth/lib/types';

import { LS_IS_JUST_SIGNED_IN_NAME, LS_IS_JUST_SIGNED_IN_VALUE } from '@/entities/user/currentUser';
import { useViewerStore } from '@/entities/viewer';

import { AUTH_API } from '@/shared/api/amplify';
import { showErrorAlert } from '@/shared/lib/showErrorAlert';
import { AuthForm } from '@/shared/types/Cognito';

import { SubmitButton } from './styled';

export const GoogleSigninButton = () => {
  const [isLoading, setIsLoading] = useState(false);

  const authForm = useViewerStore((state) => state.authForm);

  const handleGoogleLogin = async () => {
    try {
      setIsLoading(true);
      await wait(1000);
      await AUTH_API.socialSignIn(CognitoHostedUIIdentityProvider.Google);
      localStorage.setItem(LS_IS_JUST_SIGNED_IN_NAME, LS_IS_JUST_SIGNED_IN_VALUE);
    } catch (e) {
      showErrorAlert(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <SubmitButton disabled={isLoading} isLoading={isLoading} onClick={handleGoogleLogin}>
      Sign{authForm === AuthForm.Signup ? ' up ' : ' in '}with Google
    </SubmitButton>
  );
};
